import React, { memo } from 'react';
import PropTypes from 'prop-types';
var Base = function Base(_ref) {
  var children = _ref.children,
    type = _ref.type;
  return /*#__PURE__*/React.createElement("div", {
    className: "alert alert-".concat(type),
    role: "alert"
  }, children);
};
Base.propTypes = {
  type: PropTypes.oneOf(['success', 'info', 'warning', 'danger']).isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};
export default /*#__PURE__*/memo(Base);